import PropTypes from "prop-types";
import useDialer from "./hooks/use-dialer";
import DialerNumPad from "./components/dialer-num-pad";
import DialerNumbersDropdown from "./components/dialer-numbers-dropdown";
import DialerInputField from "./components/dialer-input-field";

const Dialer = ({ contact, name, phones }) => {
  const {
    phoneRef,
    extensionRef,
    phoneNumber,
    extension,
    onPhoneFocus,
    onExtFocus,
    handleInput,
    handleDropdownInput,
    CallerButton,
  } = useDialer(contact.id);

  return (
    <div className="dialer">
      <div className="dialer--contact-info">
        <DialerNumbersDropdown
          name={name}
          phones={phones}
          handleNumberChange={handleDropdownInput}
          value={phoneNumber}
        />
        <DialerInputField
          phoneRef={phoneRef}
          extensionRef={extensionRef}
          phoneNumber={phoneNumber}
          extension={extension}
          onPhoneFocus={onPhoneFocus}
          onExtFocus={onExtFocus}
          handleInput={handleInput}
        />
        <CallerButton />
      </div>
      <DialerNumPad handleNumPadPress={handleInput} />
    </div>
  );
};

/**
 * PropTypes for the Dialer component:
 * - phones: An array of phone numbers.
 * - name: The name of the contact.
 * - contact: The contact object.
 */
Dialer.propTypes = {
  phones: PropTypes.array,
  name: PropTypes.string,
  contact: PropTypes.object,
};

export default Dialer;
